export const CREATE_STREAM ="signIn";
export const SEND_OTP = "sendingOtp";